import antLocale from 'antd/lib/locale/en_US';
import translations from './translations.json';

export default {
  name: 'English',
  translations,
  antLocale,
};
